import { Injectable } from '@angular/core';
import { Utils } from '../../../../common/js/Utils';
import { TermQuotePremiumBreakdown, WholeLifeQuotePremiumBreakdown } from '../../../js/interfaces/CoverpathTypes';

@Injectable()
export class PremiumCalculationService {
  public static calculateWholeLifePremium(breakdown: WholeLifeQuotePremiumBreakdown): WholeLifeQuotePremiumBreakdown {
    if (breakdown.basePremium) {
      let total = breakdown.basePremium;
      if (breakdown.hasWaiver) {
        total += breakdown.waiver;
      }

      if (breakdown.hasGirRider) {
        //if GIR is selected, include GIR premium and waiver (if applicable)
        if (breakdown.hasWaiver) {
          breakdown.waiver += breakdown.girWaiver;
          total += breakdown.girWaiver;
        }
        total += breakdown.girPremium;
      }

      if (breakdown.hasRtrRider) {
        //if RTR is selected, include RTR premium and waiver (if applicable)
        if (breakdown.hasWaiver) {
          breakdown.waiver += breakdown.rtrWaiver;
          total += breakdown.rtrWaiver;
        }
        if (breakdown.rtrFlatExtras) {
          breakdown.rtrFlatExtras.forEach((fe) => {
            total += fe.premium;
          });
        }
        total += breakdown.rtrPremium;
      }

      if (breakdown.flatExtras) {
        breakdown.flatExtras.forEach((fe) => {
          total += fe.premium;
        });
      }

      if (breakdown.alirEnabled) {
        // In order to avoid circular logic, changes to alir.amount don't always notify
        // alir.premium watchers. Thus alir.amount should be used over alir.premium in ng form logic
        if (breakdown.paymentFrequency.toLowerCase() === 'annual') {
          breakdown.alirPremium = breakdown.alirAmount;
        } else {
          breakdown.alirPremium = Utils.round(breakdown.alirAmount / 12, 2);
        }
        total += breakdown.alirPremium;
      }

      if (breakdown.hasCirRider) {
        //if CIR is selected, include CIR premium and waiver (if applicable)
        if (breakdown.hasWaiver) {
          breakdown.waiver += breakdown.cirWaiver;
          total += breakdown.cirWaiver;
        }
        total += breakdown.cirPremium;
      }
      breakdown.totalPremium = total;
    }
    return breakdown;
  }

  public static calculateTermLifePremium(breakdown: TermQuotePremiumBreakdown): TermQuotePremiumBreakdown {
    let total = breakdown.basePremium;
    if (breakdown.basePremium && breakdown.hasWaiver && breakdown.waiver) {
      total += breakdown.waiver;
    }
    if (breakdown.flatExtras) {
      breakdown.flatExtras.forEach((fe) => (total += fe.premium));
    }
    breakdown.totalPremium = total;
    return breakdown;
  }
}
